import { RootState } from "../rootReducer"

export const selectSendSignUpEmailState = (state: RootState) => state.signUp.sendSignUpEmail
export const selectSentEmailAddress = (state: RootState) => state.signUp.sendSignUpEmail.data
export const selectVerifySignUpCodeState = (state: RootState) => state.signUp.verifySignUpCode
export const selectSignUpByEmailState = (state: RootState) => state.signUp.signUpByEmail
